import * as React from "react";
import AsyncSelect from 'react-select/async';
import axios from "axios";

type Props = {
    handleSelect: (value: string) => void
}

type State = {
    value: string,
}

type suburbObject = {
    value: string,
    label: string,
}

const url = (window as any).c4k.urls.locationAutocomplete

export class SuburbAutocomplete extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
        };
    }

    state: State = {
        value: null,
    }

    // Filter logic
    GetSuggestions = (value) => {
        const inputValue = value.trim().toLowerCase();

        let queryUrl = url + "?term=" + inputValue;

        if (inputValue.length > 2) {

            return new Promise<Array<suburbObject>>((resolve, reject) => {
                axios.get(queryUrl).then((response: any) => {

                    // Format to an array that matches the value label structure
                    let results = response.data.map(suburb => {
                        return {
                            value: suburb.key, label: suburb.label
                        }
                    })

                    resolve(results)
                })
                    .catch(error => {
                        console.log('Suburb search error', error)
                    })
            })
        }
    };

    HandleChange = (value) => {
        this.props.handleSelect(value.value)
    }

    render() {

        return (
            <AsyncSelect
                loadOptions={this.GetSuggestions}
                onChange={this.HandleChange}
                className="h-10"
                placeholder="Enter suburb to search..."
            />
        );
    }
}